module.exports = __webpack_public_path__ + "img/03.51113e9d.jpg";